import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { PortalShell } from "@/components/layout/PortalShell";
import { AGENT_NAV } from "@/lib/agent-nav";
import { AnnouncementsInbox } from "@/components/portal/AnnouncementsInbox";

export const Route = createFileRoute("/agent/announcements")({
  head: () => ({ meta: [{ title: "Announcements — Strategist Portal" }, { name: "robots", content: "noindex" }] }),
  component: () => (
    <ProtectedRoute requiredRole="agent">
      <PortalShell title="Strategist Portal" nav={AGENT_NAV} tourKey="agent_tour">
        <AnnouncementsInbox audience="agent" />
      </PortalShell>
    </ProtectedRoute>
  ),
});